import React, { FC, useMemo } from 'react';

import {
  SegmentedControl,
  SegmentedControlBaseOption,
} from 'app/design-system/components/SegmentedControl';
import { useTranslation } from 'app/lang';
import { Theme, ToggleThemeState, useTheme } from 'app/lib/theme';

import DropdownMenuItem from '../DropdownMenu/DropdownMenuItem';

import dictionary from './ThemeToggleItem.dictionary.json';

import styles from './ThemeToggleItem.module.scss';

const ThemeToggleItem: FC = () => {
  const { theme, isSystemTheme: useSystem, setTheme } = useTheme();
  const { t } = useTranslation();

  const onSelectHandler = ({ id }: SegmentedControlBaseOption<ToggleThemeState>) => {
    setTheme(id);
  };

  const options = useMemo(
    () => [
      {
        id: ToggleThemeState.LIGHT,
        value: t(dictionary.lightThemeLabel),
        dataTest: 'themeControl-option-light',
        dataGaEvent: 'theme-select',
        dataGaEventValue: 'light',

      },
      {
        id: ToggleThemeState.DARK,
        value: t(dictionary.darkThemeLabel),
        dataTest: 'themeControl-option-dark',
        dataGaEvent: 'theme-select',
        dataGaEventValue: 'dark',
      },
      {
        id: ToggleThemeState.SYSTEM,
        value: t(dictionary.systemThemeLabel),
        dataTest: 'themeControl-option-system',
        dataGaEvent: 'theme-select',
        dataGaEventValue: 'system',
      },
    ],
    [],
  );

  const getSelectedId = () => {
    if (useSystem) {
      return ToggleThemeState.SYSTEM;
    }

    if (theme === Theme.DARK) {
      return ToggleThemeState.DARK;
    }

    return ToggleThemeState.LIGHT;
  };

  return (
    <DropdownMenuItem divider="top"
                      className={styles.root}>
      <h2 className={styles.title}
          data-test="preferences-subtitle">
        {t(dictionary.toggleLabel)}
      </h2>
      <SegmentedControl
        options={options}
        onSelect={onSelectHandler}
        className={styles.items}
        selectedId={getSelectedId()} />
    </DropdownMenuItem>
  );
};

export default ThemeToggleItem;
